import React from "react";
import { useNavigate } from "react-router-dom";
import { FiPlus, FiArrowRight, FiFileText, FiPackage } from "react-icons/fi";

const SupplierRQMSection = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full py-8 px-4 md:px-8 bg-gradient-to-b from-[#FFFDFD] to-[#FBF8F8]">
      <div className="2xl:max-w-7xl mx-auto">
        {/* HEADER SECTION */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primaryColor/10 text-primaryColor text-xs font-semibold mb-2">
              <FiFileText size={14} /> Requirement Quote Match
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-gray-900 tracking-tight">
              Supplier RQM Portal
            </h2>
            <p className="text-xs md:text-sm text-gray-500 mt-1 max-w-2xl leading-relaxed">
              Post your product requirements, specify quantities and pricing, and get fast approval from admins for high-demand market matching.
            </p>
          </div>

          {/* ACTION BUTTONS */}
          <div className="flex items-center gap-3 flex-wrap">
            <button
              onClick={() => navigate("/post-rqm-request")}
              className="flex items-center gap-2 bg-primaryColor hover:bg-primaryColor/90 text-white font-semibold text-sm px-5 py-2.5 rounded-xl shadow-md transition duration-200 active:scale-95"
            >
              <FiPlus size={18} /> Post New RQM Request
            </button>
            {/* <button
              onClick={() => navigate("/supplier-linked-varieties")}
              className="flex items-center gap-2 bg-white border border-gray-300 text-gray-700 hover:text-primaryColor hover:border-primaryColor font-semibold text-sm px-4 py-2.5 rounded-xl shadow-2xs transition duration-200"
            >
              <FiPackage size={16} /> Linked Products
            </button> */}
            <button
              onClick={() => navigate("/supplier-rqm-requests")}
              className="flex items-center gap-2 bg-white border border-gray-300 text-gray-700 hover:text-primaryColor hover:border-primaryColor font-semibold text-sm px-4 py-2.5 rounded-xl shadow-2xs transition duration-200"
            >
              View Requests <FiArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupplierRQMSection;
